<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>{{ 'components.responses.view_questionnaire_response' | translate}}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="!loading ? closeDialogue() : ''"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<mat-dialog-content class="m-0 p-0" [style.max-height]="data.isAnonymous ? '80vh' : '100vh'">
  <div class="container-fluid p-0">
    <app-survey-response-page [surveyID]="data?.surveyID" [impersonateEmail]="data.impersonateEmail" [isAnonymous]="data.isAnonymous"/>
  </div>
</mat-dialog-content>
